import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import config from "../config";
import { postApi } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
  observe,
} from "mobx";
import { act } from "react-dom/test-utils";

class PassengerStore {
  passengers = [];
  rootTripListArray = [];
  assetVehicleList = [];
  getClass = [];
  // users=[]
  // drivers=[]
  // staff=[]
  // passengers=[]
  total = 0;
  loading = false;
  rootStore;
  photoFromDb = {};

  constructor(rootStore) {
    makeObservable(this, {
      passengers: observable,
      rootTripListArray: observable,
      assetVehicleList: observable,
      getClass: observable,
      total: observable,
      loading: observable,
      photoFromDb: observable,
      loadData: action,
      deleteRecord: action,
      getRouteTripList: action,
      addData: action,
      sampleExcelFormat: action,
      addStudentByExcel: action,
      reAssignVehicle: action,
      getAllClass: action,
      getBusNo: action,
    });
    this.rootStore = rootStore;
  }
  async getCompany({ companyName }) {
    var postData = { name: companyName };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=searchCompany", "postData=" + base64Input);
    console.log(response);
  }
  async loadData({ offset, limit, searchField, companyId }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      offset: offset,
      limit: limit,
      searchField: searchField,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=passenger&a=passdetails", "postData=" + base64Input);
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/passenger/get-passenger-details", {
        params: postData,
      });
    this.passengers = response?.data?.data?.passengers;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }
  async setPhotoFromDb(photo) {
    console.log(photo);
    this.photoFromDb = { fileList: photo };
  }
  async getPassenger(passengerId, limit, offset) {
    console.log(passengerId, "id");
    const postData = { passengerId: passengerId, limit: 1, offset: 0 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/passenger/get-passenger-details", {
        params: postData,
      });
    const singleRow = response?.data?.data?.passengers[0];

    if (singleRow.photo) {
      const fileList = [
        {
          name: singleRow.photo,
          status: "success",
          url: config.fleetURL + "/images/students/" + singleRow.photo,
        },
      ];

      await this.setPhotoFromDb(fileList);
    }
    return singleRow;
  }

  async deleteRecord({ passengerId }) {
    var postData = { passengerId: passengerId };
    var queryParams = { passengerId: passengerId };
    var response = await postApi
      .getClient()
      .delete(config.NodeUrl + "/passenger/delete", {
        params: queryParams,
      });
    return response;
  }

  async addData(studentData) {
    var response = await postApi
      .getClient()
      .post(config.NodeUrl + "/passenger/createOrUpdate", studentData);

    return response.data;
  }

  async getRouteTripList({
    companyId,
    pickuplatitude,
    pickuplongitude,
    classId,
    offset,
    limit,
    userId,
    isadmin,
  }) {
    var postData = {
      companyId: companyId,
      pickuplatitude: pickuplatitude,
      pickuplongitude: pickuplongitude,
      classId: classId,
      userId: userId,
      isadmin: isadmin,
      offset: offset,
      limit: limit,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=passenger&a=getRouteTripList",
        "postData=" + base64Input
      );
    this.rootTripListArray = response;
    console.log(response);
  }

  async sampleExcelFormat() {
    // window.location.href = config.baseURL + "index.php?c=vehicle&a=exportloginexcel&cid=" +getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + '&uId=' + getDta.userid + '&colList=' + getDta.colList
    window.location.href =
      "https://awtltrack.com/public/fleet/appRes/excel/Student.xlsx";
  }

  // async sampleExcelFormat() {
  //   window.location.href = config.fleetURL + "/appRes/excel/Student.xlsx";
  // }

  async addStudentByExcel(excelFile) {
    this.excelLoadig = true;
    var postData = excelFile;

    var response = await postApi
      .getClient()
      .post(config.NodeUrl + "/passenger/passengerImport", postData);
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=passenger&a=studentexcel2", "postData=" + base64Input);
    this.excelLoadig = false;
    return response.data;
  }

  async reAssignVehicle(renewData) {
    // console.log("vehicle list")
    var postData = renewData;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(config.NodeUrl + "/passenger/reAssignVehicle", renewData);
    return response.data;
  }

  async getAllClass() {
    // console.log("vehicle list")
    var postData = null;
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=notification&a=getAllClass",
        "postData=" + base64Input
      );
    // console.log(response?.data?.data, "post")
    this.getClass = response?.data?.data;
    return response?.data?.data;
  }

  async getBusNo(companyId) {
    // console.log("companyId", companyId)
    var postData = {
      companyId: companyId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
    console.log(response, "post");
    // let allVehicles = [{ "vehicleId": 0, "vehicleNo": "ALL" }];

    this.assetVehicleList = response?.data?.data;
    return response?.data?.data;
  }
}

export default PassengerStore;
